export class tokenStorage {
    static get LOCAL_STORAGE_TOKEN() {
        return '__token';
    }

    static get LOCAL_STORAGE_REFRESH_TOKEN() {
        return '__security';
    }

    // Cookie names
    static get COOKIE_TOKEN() {
        return '__token';
    }

    static get COOKIE_REFRESH_TOKEN() {
        return '__security';
    }

    static get COOKIE_USER_ID() {
        return '__uid';
    }

    static get COOKIE_SESSION_ID() {
        return '__s';
    }

    // Cookie expiration (30 days)
    static get COOKIE_EXPIRATION_DAYS() {
        return 30;
    }

    // Helper functions for cookies
    static setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        const secureFlag = window.location.protocol === 'https:' ? ';Secure' : '';
        document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax${secureFlag}`;
    }

    static getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    }

    static deleteCookie(name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    }

    static clear() {
        // Clear localStorage
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_TOKEN);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_SESSION_ID);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_USER_ID);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_USER_FULL_NAME);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY);
        localStorage.removeItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV);

        // Clear cookies
        tokenStorage.deleteCookie(tokenStorage.COOKIE_TOKEN);
        tokenStorage.deleteCookie(tokenStorage.COOKIE_REFRESH_TOKEN);
        tokenStorage.deleteCookie(tokenStorage.COOKIE_USER_ID);
        tokenStorage.deleteCookie(tokenStorage.COOKIE_SESSION_ID);
        tokenStorage.deleteCookie(tokenStorage.COOKIE_ENCRYPTION_KEY);
        tokenStorage.deleteCookie(tokenStorage.COOKIE_ENCRYPTION_IV);

        return true;
    }

    static storeToken(token) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_TOKEN, token);
        // Also store in cookie for persistence
        if (token) {
            tokenStorage.setCookie(tokenStorage.COOKIE_TOKEN, token, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getToken() {
        // First try localStorage
        let token = localStorage.getItem(tokenStorage.LOCAL_STORAGE_TOKEN);
        // If not found, try cookie and restore to localStorage
        if (!token) {
            token = tokenStorage.getCookie(tokenStorage.COOKIE_TOKEN);
            if (token) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_TOKEN, token);
            }
        }
        return token;
    }

    // REFRESH Token
    static storeRefreshToken(token) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN, token);
        // Also store in cookie for persistence
        if (token) {
            tokenStorage.setCookie(tokenStorage.COOKIE_REFRESH_TOKEN, token, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getRefreshToken() {
        // First try localStorage
        let token = localStorage.getItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN);
        // If not found, try cookie and restore to localStorage
        if (!token) {
            token = tokenStorage.getCookie(tokenStorage.COOKIE_REFRESH_TOKEN);
            if (token) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN, token);
            }
        }
        return token;
    }

    // SESSION ID
    static get LOCAL_STORAGE_SESSION_ID() {
        return '__s';
    }

    static storeSessionId(session) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_SESSION_ID, session);
        // Also store in cookie for persistence
        if (session) {
            tokenStorage.setCookie(tokenStorage.COOKIE_SESSION_ID, session, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getSessionId() {
        // First try localStorage
        let session = localStorage.getItem(tokenStorage.LOCAL_STORAGE_SESSION_ID);
        // If not found, try cookie and restore to localStorage
        if (!session) {
            session = tokenStorage.getCookie(tokenStorage.COOKIE_SESSION_ID);
            if (session) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_SESSION_ID, session);
            }
        }
        return session;
    }

    // USER ID
    static get LOCAL_STORAGE_USER_ID() {
        return '__uid';
    }

    static storeUserId(token) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_USER_ID, token);
        // Also store in cookie for persistence
        if (token) {
            tokenStorage.setCookie(tokenStorage.COOKIE_USER_ID, token, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getUserId() {
        // First try localStorage
        let userId = localStorage.getItem(tokenStorage.LOCAL_STORAGE_USER_ID);
        // If not found, try cookie and restore to localStorage
        if (!userId) {
            userId = tokenStorage.getCookie(tokenStorage.COOKIE_USER_ID);
            if (userId) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_USER_ID, userId);
            }
        }
        return userId;
    }

    static get LOCAL_STORAGE_USER_FULL_NAME() {
        return '__user_full_name';
    }

    static storeUserFullName(token) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_USER_FULL_NAME, token);
    }

    static getUserFullName() {
        return localStorage.getItem(tokenStorage.LOCAL_STORAGE_USER_FULL_NAME);
    }

    // ENCRYPTION KEY
    static get LOCAL_STORAGE_ENCRYPTION_KEY() {
        return '__encryption_key';
    }

    static get COOKIE_ENCRYPTION_KEY() {
        return '__encryption_key';
    }

    static storeEncryptionKey(key) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY, key);
        // Also store in cookie for persistence
        if (key) {
            tokenStorage.setCookie(tokenStorage.COOKIE_ENCRYPTION_KEY, key, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getEncryptionKey() {
        // First try localStorage
        let key = localStorage.getItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY);
        // If not found, try cookie and restore to localStorage
        if (!key) {
            key = tokenStorage.getCookie(tokenStorage.COOKIE_ENCRYPTION_KEY);
            if (key) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY, key);
            }
        }
        return key;
    }

    // ENCRYPTION IV (Initialization Vector)
    static get LOCAL_STORAGE_ENCRYPTION_IV() {
        return '__encryption_iv';
    }

    static get COOKIE_ENCRYPTION_IV() {
        return '__encryption_iv';
    }

    static storeEncryptionIV(iv) {
        localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV, iv);
        // Also store in cookie for persistence
        if (iv) {
            tokenStorage.setCookie(tokenStorage.COOKIE_ENCRYPTION_IV, iv, tokenStorage.COOKIE_EXPIRATION_DAYS);
        }
    }

    static getEncryptionIV() {
        // First try localStorage
        let iv = localStorage.getItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV);
        // If not found, try cookie and restore to localStorage
        if (!iv) {
            iv = tokenStorage.getCookie(tokenStorage.COOKIE_ENCRYPTION_IV);
            if (iv) {
                localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV, iv);
            }
        }
        return iv;
    }

    // Preload session from cookies on page load
    static preloadSessionFromCookies() {
        // Restore token from cookie if not in localStorage
        const token = tokenStorage.getCookie(tokenStorage.COOKIE_TOKEN);
        if (token && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_TOKEN)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_TOKEN, token);
        }

        // Restore refresh token from cookie if not in localStorage
        const refreshToken = tokenStorage.getCookie(tokenStorage.COOKIE_REFRESH_TOKEN);
        if (refreshToken && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
        }

        // Restore user ID from cookie if not in localStorage
        const userId = tokenStorage.getCookie(tokenStorage.COOKIE_USER_ID);
        if (userId && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_USER_ID)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_USER_ID, userId);
        }

        // Restore session ID from cookie if not in localStorage
        const sessionId = tokenStorage.getCookie(tokenStorage.COOKIE_SESSION_ID);
        if (sessionId && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_SESSION_ID)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_SESSION_ID, sessionId);
        }

        // Restore encryption key from cookie if not in localStorage
        const encryptionKey = tokenStorage.getCookie(tokenStorage.COOKIE_ENCRYPTION_KEY);
        if (encryptionKey && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_KEY, encryptionKey);
        }

        // Restore encryption IV from cookie if not in localStorage
        const encryptionIV = tokenStorage.getCookie(tokenStorage.COOKIE_ENCRYPTION_IV);
        if (encryptionIV && !localStorage.getItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV)) {
            localStorage.setItem(tokenStorage.LOCAL_STORAGE_ENCRYPTION_IV, encryptionIV);
        }
    }

}
